import { createTheme } from '@mui/material';
import colors from '../assets/scss/palette.scss';
import themePalette from './palette';
export const theme = () => {
  
    const themeOption = {
      colors,
    }
  
    const themeOptions = {
      palette: themePalette(themeOption),
    };
  
    const themes = createTheme(themeOptions);
  
    return themes;
};